// src/blogs/BlogNavContext.js
// Hands App's veil-covered navigation down to post links, which are rendered
// deep inside each blog's post components (so prop-drilling it would touch
// every layer in between). Provided by BlogSceneRoute; without a provider,
// links fall back to plain navigation.
import { createContext, useContext } from "react";

export const BlogNavContext = createContext({ veilNavigate: null });

export function useBlogNavigation() {
  return useContext(BlogNavContext);
}
